"use strict";
exports.__esModule = true;
exports.fontSize = void 0;
var core_1 = require("@tiptap/core");
require("@tiptap/extension-text-style");
exports.fontSize = core_1.Extension.create({
    name: "fontSize",
    defaultOptions: {
        types: ["textStyle"]
    },
    addGlobalAttributes: function () {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        "default": null,
                        renderHTML: function (attributes) {
                            if (!attributes.fontSize) {
                                return {};
                            }
                            return {
                                style: "font-size:" + (attributes.fontSize.fontSize ? attributes.fontSize.fontSize : attributes.fontSize) + ";"
                            };
                        },
                        parseHTML: function (element) { return ({
                            fontSize: element.style.fontSize.replace(/['"]+/g, "")
                        }); }
                    }
                }
            }
        ];
    },
    addCommands: function () {
        return {
            setSize: function (fontSize) {
                return function (_a) {
                    var chain = _a.chain;
                    return chain().setMark("textStyle", { fontSize: fontSize }).run();
                };
            }
        };
    }
});
